import type { APILibraryTemplateResponseType } from "./APILibraryTemplate";
import type { APILibraryVerticalResponseType } from "./APILibraryVertical";

export type APILibraryTemplatePackStatus = "active" | "disabled";

export type APILibraryTemplatePackResponseType = Partial<{
  id: number;
  url: string;
  name: string;
  description: string;
  status: APILibraryTemplatePackStatus;
  verticals: APILibraryVerticalResponseType[];
  templates: APILibraryTemplateResponseType[];
  created: string;
  modified: string;
}>;
export type APILibraryTemplatePackRequestType = Partial<{
  name: string;
  description: string;
  status: APILibraryTemplatePackStatus;
  verticals: string[];
  templates: string[];
}>;
export interface IAPILibraryTemplatePack {
  getData(): APILibraryTemplatePackResponseType;
  isDataValid(): boolean;
  toRequestModel(): APILibraryTemplatePackRequestType;
}
export class APILibraryTemplatePack implements IAPILibraryTemplatePack {
  readonly data: APILibraryTemplatePackResponseType;
  constructor(data: APILibraryTemplatePackResponseType) {
    this.data = data;
  }
  getData(): APILibraryTemplatePackResponseType {
    return this.data;
  }
  isDataValid(): boolean {
    return !!this.data.name;
  }
  toRequestModel(): APILibraryTemplatePackRequestType {
    if (this.isDataValid()) {
      return {
        name: this.data.name!.trim(),
        description: this.data.description ?? "",
        status: this.data.status ?? "active",
        verticals: this.data.verticals?.map((vertical) => vertical.url ?? ""),
        templates: this.data.templates?.map((template) => template.url ?? ""),
      };
    }
    throw new Error("Invalid data: name is required");
  }
}
